var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fin-chart-list',{staticClass:"market-wrapper-chart-list",attrs:{"items":_vm.items,"no-preview":_vm.$vuetify.breakpoint.xsOnly},on:{"input":_vm.chartsLoaded,"selectedItem":_vm.selectedChartChange}})}
var staticRenderFns = []

export { render, staticRenderFns }